import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'confirm-dialog',
  template: `
    <h2 mat-dialog-title>Conferma</h2>
    <mat-dialog-content class="mat-typography">
      <mat-label [innerHtml]="message"></mat-label>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false" color="warn">Annulla</button>
      <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Continua</button>
    </mat-dialog-actions>
  `,
})
export class ConfirmDialogComponent implements OnInit {
  message!: string;
  constructor(@Inject(MAT_DIALOG_DATA) private data: { message: string }) {}
  ngOnInit(): void {
    this.message = this.data?.message;
  }
}
